import { render, staticRenderFns } from "./HowManySeats.vue?vue&type=template&id=75b7f053&"
import script from "./HowManySeats.vue?vue&type=script&lang=js&"
export * from "./HowManySeats.vue?vue&type=script&lang=js&"
import style0 from "./HowManySeats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports